// extracted by mini-css-extract-plugin
export default {"iconWrapper":"gmC8E92xVb6T3egWvEjU","title":"BtOd0ybAo8kDs0_kJil7","leftColumn":"nDxvl5xOr1KkwBHXzNgh","footer":"l7U3ClG_9WKstPUh2Mtm","rightColumn":"FKJySOZ5eVpkZNYuE3ID"};